import styled from 'styled-components';

export const StyledStep = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.marginXS}px;
  height: inherit;

  .open-image-tags-drawer-btn {
    align-self: flex-end;
  }

  .images-container {
    flex-grow: 1;
    flex-shrink: 1;
    overflow-y: auto;
    width: inherit;

    .image-list {
      margin: 0 !important;

      .ant-image-img {
        object-fit: cover;
        aspect-ratio: 1 / 1;
      }
    }

    &.single-image {
      .ant-image {
        width: 100%;
      }
    }
  }

  .image-preview-footer {
    display: flex;
    flex-direction: column;
    gap: ${({ theme: { token } }) => token.marginLG}px;
    padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.paddingXS}px 0
      ${({ theme: { token } }) => token.paddingXS}px;

    .mobile-image-select-upload {
      width: 100%;

      .ant-upload {
        width: inherit;
      }
    }
  }
`;
